import React from 'react'
import TopPanelMenu from 'components/TopPanelMenu'

export default class extends React.Component {
  render() {
    return (
      <TopPanelMenu
        items={[
          {to: '/conversions/conversion-count', title: 'Conversion Count'}
          // {to: '/conversions/conversion-amount', title: 'Revenue'}
        ]}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/OrdersOverviewView/menu.js